import BusinessCategoryAddPage from './BusinessCategoryAddPage';

export default BusinessCategoryAddPage;
